<template>
    <div>
        <div class="img">
            <img src="../assets/404.jpg">
        </div>   
    </div>
</template>

<script>

export default ({
    name:'404'
})
</script>

<style scoped>
.img{
    margin-top:100px ;
}
</style>